var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.gifted)?_c('p',{staticClass:"gifted-review-notice"},[_vm._v(" "+_vm._s(_vm.$t('giftedProductReviewNotice'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }